import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withTooltip } from '@/utils';
import { UserIcon } from '../icons';
export var GenderPreference = function (_a) {
    var gender = _a.gender;
    if (!(gender === null || gender === void 0 ? void 0 : gender.length))
        return null;
    return (_jsxs("div", { className: 'flex items-baseline gap-1', children: [withTooltip('Gender Preference', true, _jsx(UserIcon, {})), _jsx("span", { children: gender.map(function (item, key) {
                    var label = '';
                    if (item === 'male')
                        label = 'Male';
                    if (item === 'female')
                        label = 'Female';
                    if (item === 'other')
                        label = 'Other';
                    return (_jsxs("span", { children: [label, key < gender.length - 1 && _jsx("i", { children: ", " })] }, key));
                }) })] }));
};
